import { render } from "./IntroMetodoCientifico.vue?vue&type=template&id=7db3a19c&scoped=true"
import script from "./IntroMetodoCientifico.vue?vue&type=script&lang=js"
export * from "./IntroMetodoCientifico.vue?vue&type=script&lang=js"

import "./IntroMetodoCientifico.vue?vue&type=style&index=0&id=7db3a19c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db3a19c"]])

export default __exports__